export default __webpack_public_path__ + "static/media/764.88bcdc13.png";